import useCollectedUserData from './useCollectedUserData';

const useUserPointSum = () => {
  const { userPointSum } = useCollectedUserData();
  return userPointSum;
};

export default useUserPointSum;
